<template>
  <div class="welcome wbg">
    <AddDislog ref="dislog" @resh='turnpage(1)'> </AddDislog>
    <div class="top">
      <a-row class="row" :gutter="40">
        <a-col class="flex" :span="6">
          <label style="width: 85px;text-align: right;">债务人：</label>
          <a-input placeholder='请输入债务人姓名' v-model='form.realname'> </a-input>
        </a-col>
        <a-col class="flex" :span="7">
          <label>债务人证件号码：</label>
          <a-input placeholder='请输入债务人证件号码' v-model='form.chinaid'> </a-input>
        </a-col>
        <a-col class="flex" :span="5">
          <label>函件类型：</label>
          <a-select v-model="form.letters_type" placeholder="请选择" class="select" :allowClear='true'>
            <a-select-option v-for="item in letters_type" :key="item.label" :value="item.id">{{ item.label
            }}</a-select-option>
          </a-select>
        </a-col>
        <a-col class="flex" :span="6">
          <label>函号：</label>
          <a-input placeholder='请输入函号' v-model='form.no'> </a-input>
        </a-col>
      </a-row>
      <a-row class="row" :gutter="40">
        <a-col :span="6" class="flex">
          <label>寄出时间：</label>
          <timePick @PickTime="PickTime" ref="timePicker"></timePick>
        </a-col>
        <a-col class="flex" :span="7">
          <label style="width: 145px;text-align: right;">委托人：</label>
          <a-select v-model="form.accuser_id" placeholder="请选择" class="select" mode="multiple" :maxTagCount='1'
            :maxTagTextLength='12' :filter-option="$common.filterOption">
            <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id">{{ item.title
            }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="8" class="flex">
          <a-button icon="search" type="primary" @click='turnpage(1)'
            style="margin-right:20px;height:32px;">查询</a-button>
          <a-button @click='reset' style="margin-right:20px;height:32px;">重置</a-button>
          <!-- <a-button v-if="$common.AUTH('1-2-3')" icon="upload" @click="download()" type="primary" ghost>导出</a-button> -->
          <a-button type="primary" icon='plus' ghost style="height:32px;"
            @click="$refs.dislog.visible = true">新增</a-button>
        </a-col>
      </a-row>
    </div>
    <div class="tcon">
      <div class="tableList">
        <div class="table">
          <table>
            <thead>
              <td width='54'>序号</td>
              <td width='72'>债务人</td>
              <td width='130'>债务人证件号码</td>
              <td width="100">函件类型</td>
              <td width="160">函件名称</td>
              <td width='240'>委托人</td>
              <td width='180'>寄出时间</td>
              <td width='98' style="padding-left:30px;">录入日期</td>
            </thead>
            <tbody>
              <tr v-for='(i, index) in data' :key='index'>
                <td>{{ 10 * (form.page - 1) + index + 1 }}</td>
                <td><span class="curpoter" @click='dbclick(i)'> {{ i.realname }}</span></td>
                <td>{{ i.chinaid }}</td>
                <td>
                  <p v-for='(j, index) in i.letters' :key="index">
                    {{ j.letters_type | rName }}
                  </p>
                </td>
                <td>
                  <p v-for='(j, index) in i.letters' :key="index">
                    <Normap :tit='j.title'>{{ j.title }}</Normap>
                  </p>
                </td>
                <td>
                  <p v-for='(j, index) in i.letters' :key="index">
                    <Normap :tit='j.accuser.title'>{{ j.accuser.title }}</Normap>
                  </p>
                </td>
                <td>
                  <p v-for='(j, index) in i.letters' :key="index">
                    <Normap :tit='j.ship_time'>{{ j.ship_time }}</Normap>
                  </p>
                </td>
                <td>
                  <p v-for='(j, index) in i.letters' :key="index">
                    {{ j.create_time | yearFormat }}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pages">
          <a-pagination v-model="form.page" show-quick-jumper :total="total" show-less-items :pageSize='10'
            @change='turnpage' :show-total="(total) => `债务人：${total}`" />
        </div>
      </div>
      <!-- <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div> -->
    </div>
  </div>
</template>
<script>
import { getAccuserAll, Ldebtor } from '@/server/api'
import { letters_type, rName } from './keys'
import AddDislog from './add.vue'
export default {
  components: { AddDislog },
  data() {
    return {
      letters_type: letters_type,
      data: [],
      total: 0,
      accuserList: [],
      form: {
        page: 1,
        limit: 10,
        chinaid: '',
        start_time: '',
        end_time: '',
        no: '',
        accuser_id: [],
        realname: ''
      },
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    getAccuserAll().then((res) => {
      this.accuserList = res.list
    })
  },
  filters: {
    rName
  },
  methods: {
    turnpage(val) {
      this.form.page = val;
      this.getList()
    },
    reset() {
      this.form.limit = 10
      this.form.page = 1
      this.form.realname = ''
      this.form.chinaid = ''
      this.form.letters_type = undefined
      this.form.no = ''
      this.form.accuser_id = []
      this.form.start_time = ''
      this.form.end_time = ''
      this.$refs.timePicker.clearTime()
      this.getList()
    },
    dbclick(record) {
      if (this.$common.AUTH('debtor:info')) {
        let routeUrl = this.$router.resolve({ "name": "ldetails", params: { "id": record.id } });
        window.open(routeUrl.href, '_blank');
      }
      else {
        this.$message.error({ content: '暂无权限', key: 'updatable' });
      }
    },
    getList(val) {
      const form = JSON.parse(JSON.stringify(this.form))
      form.accuser_id = form.accuser_id.toString()
      Ldebtor('index', form).then(e => {
        this.total = e.count
        this.data = e.list
      })
    },
    PickTime(e) {
      if ("stime" in e) {
        this.form.start_time = e.stime
      }
      else {
        this.form.end_time = e.etime
      }
    }
  }
}
</script>
<style lang="less" scoped>
.nowrap {
  white-space: nowrap;
}

.fixtp {
  position: absolute;
  top: -45px;
  right: 20px;
  z-index: 11;

  a {
    margin-left: 20px;
    padding: 0 20px;
    line-height: 30px;
    display: inline-block;
    border-radius: 6px;
    border: #f5222d 1px solid;
    color: #ff4d4f;

    &:hover {
      background: #ff4d4f;
      color: #fff;
    }
  }
}

.welcome {
  position: relative;

  .top {
    @import url('@/assets/css/search.less');
  }

  .tableList {
    margin-top: 20px;
    width: 100%;

    .table {
      thead {
        td {
          padding-left: 0;

          &:nth-child(1) {
            padding-left: 20px;
          }
        }
      }

      tbody {
        tr:nth-last-child(1) {
          border-bottom: 1px solid #ebebeb;
        }

        td {
          padding: 6px 0;
          height: 60px;

          &:nth-child(1) {
            padding-left: 20px;
          }

          &:nth-last-child(1) {
            padding-left: 10px;
          }

          p {
            padding: 10px 0;
            margin: 0;
            border-bottom: 1px solid #ebebeb;

            &:nth-last-child(1) {
              border: 0 none;
            }
          }
        }
      }
    }
  }

  .pages {
    text-align: right;
  }
}

.change-download {
  .ant-row {
    margin-bottom: 15px;
    line-height: 36px;

    p {
      margin: 0;
    }
  }
}
</style>
